import { useEffect, useState } from "react";
import { Fab } from "@mui/material";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import { useSelector } from "react-redux";
import { colors, spacing } from "../../assets/styles/tokens";
import { selectUserToken } from "../../features/userSlice";
import { ActionItemsEndPointLogic } from "../../logic/AssetManagement/ActionItems/actionItemsEndPointLogic";
import CreateTasksDrawer from "./CreateTasksDrawer";

interface MobileFloatingActionButtonProps {
  trackerDataId?: string;
  saveTrackerDataId?: string;
}

export default function MobileFloatingActionButton({
  trackerDataId,
  saveTrackerDataId,
}: MobileFloatingActionButtonProps) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const oauthTokenHeader = useSelector(selectUserToken);

  useEffect(() => {
    if (oauthTokenHeader) {
      ActionItemsEndPointLogic.getAllUserList(oauthTokenHeader);
    }
  }, [oauthTokenHeader]);

  return (
    <>
      <Fab
        data-tracker={trackerDataId}
        size="medium"
        color="secondary"
        aria-label="Create Tasks"
        onClick={() => setDrawerOpen(true)}
        sx={{
          backgroundColor: colors.Brand[600].$value,
          position: "fixed",
          bottom: spacing.Spacing["4xl"].$value,
          right: spacing.Spacing.xl.$value,
          "&:hover": { backgroundColor: colors.Brand[600].$value },
        }}
      >
        <AutoFixHighIcon />
      </Fab>
      <CreateTasksDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        saveTrackerDataId={saveTrackerDataId}
      />
    </>
  );
}
